<template>
  <!-- 1x2 -->
  <div class="template" v-if="newAllBetEvent.od[plytyp] && newAllBetEvent.od[plytyp][bettyp]">
    <div data-template="template1" class="wrap-template template1">
      <div class="main-handicap" :class="{ 'm-hdp': bettyp == mlBetType }">
        <div class="vrow items-center template-title is_fold">
          <div class="play-name col" @click="showLeg()">
            <span class="ellipsis">
              {{ getTitleCaption() }}
            </span>
          </div>
          <div class="" v-if="newAllBetEvent.sprbinfo"><span class="ellipsis">{{ sportTableLang.table['SPORT_TABLE.CURRENT_TOTAL'] }}: {{ newAllBetEvent.sprbinfo.scoa }}-{{ newAllBetEvent.sprbinfo.scob }}</span></div>
          <div style="width: 37px;" @click="setToTop($event)">
            <span class="set_top" style="display: none;">
              <i aria-hidden="true" role="presentation" class="q-icon icon-set_top c-icon"> </i>
            </span>
          </div>
        </div>
        <template v-if="show">
          <div class="handicap m-1x2">
            <div class="handicap-item os-1 no_border_bottom">
              <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                <div class="bet-inner yb-flex-center fit">
                  <div class="handicap-wrap">
                    <div class="bet-item">
                      <div class="item-label bet-ellipsis ellipsis" style="width: 70%;">
                        <span class="ellipsis-wrap" v-html="newAllBetEvent.oritacapt ? newAllBetEvent.oritacapt : newAllBetEvent.tacapt"></span> <!--{{ newAllBetEvent.tacapt }}-->
                        <span class="ellipsis-wrap"></span>
                      </div>
                    </div>
                  </div>
                  <odd1x2 :event="newAllBetEvent" :team="teamHome" :plyType="plytyp" :betType="bettyp" ref="team1"
                    :mode="'ab'" />
                </div>
              </div>
            </div>
            <div class=" handicap-item os-1 no_border_bottom" v-if="[onex2BetType,ronex2BetType].includes(bettyp)">
              <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                <div class="bet-inner yb-flex-center fit">
                  <div class="handicap-wrap">
                    <div class="bet-item">
                      <div class="item-label bet-ellipsis ellipsis">
                        <span class="ellipsis-wrap">{{ sportAllBetLang['ALL_BET.LBL_DRAW'] }}</span>
                        <span class="ellipsis-wrap"></span>
                      </div>
                    </div>
                  </div>
                  <odd1x2 :event="newAllBetEvent" :team="teamDraw" :plyType="plytyp" :betType="bettyp" ref="teamX"
                    :mode="'ab'" />
                </div>
              </div>
            </div>
            <div class="handicap-item os-1 no_border_bottom">
              <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                <div class="bet-inner yb-flex-center fit">
                  <div class="handicap-wrap">
                    <div class="bet-item">
                      <div class="item-label bet-ellipsis ellipsis" style="width: 70%;">
                        <span class="ellipsis-wrap" v-html="newAllBetEvent.oritbcapt ? newAllBetEvent.oritbcapt : newAllBetEvent.tbcapt"></span>
                        <!-- <span class="ellipsis-wrap">{{ newAllBetEvent.tbcapt }}</span> -->
                        <span class="ellipsis-wrap"></span>
                      </div>
                    </div>
                  </div>
                  <odd1x2 :event="newAllBetEvent" :team="teamAway" :plyType="plytyp" :betType="bettyp" ref="team2"
                    :mode="'ab'" />
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import Odd1x2Components from '../../../components/odd1x2'

import allBetMixin from '../../../mixins/allBet'

export default {
  mixins: [allBetMixin],
  props: {
    allBetEvent: null,
    plytyp: null,
    bettyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode:null
  },
  data() {
    return {
      btypes: [allBetMixin.data().onex2BetType, allBetMixin.data().ronex2BetType],
      show: true,
    }
  },
  computed: {
    ...mapGetters([
      'foldopenAllBet',
      'foldopenFirstEvent'
    ]),
    newAllBetEvent() {
      // return _.cloneDeep(this.$store.getters.sortedMatchEventList)
      return this.allBetEvent
    }
  },
  watch: {
    foldopenAllBet() {
      if(this.mode=='ab'){
        this.show = (this.$store.getters.foldopenAllBet) ? true : false;
      }
    },
    foldopenFirstEvent() {
      if(this.mode!='ab'){
        this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption() {
      var a = ''
      // var title = ''
      var sCapt = ''
      if (this.plytyp == this.ftPlyType) {
        a = '_FT'
      } else if (this.plytyp == this.firstHtPlyType) {
        a = '_1H'
      } else if (this.plytyp == this.SecondHtPlyType) {
        a = '_2H'
      } else if (this.plytyp == this.mlBetType) {
        a = '_GAME_HDP'
      } else if (this.plytyp == this.first3InningsPlayType) {
        a = '_FIRST_3_INNINGS'
      } else if (this.plytyp == this.first5InningsPlayType) {
        a = '_FIRST_5_INNINGS'
      }else if (this.plytyp == this.firstInningsPlayType) {
        a = '_FIRST_INNINGS'
      } else if (this.plytyp == this.secondInningsPlayType) {
        a = '_SECOND_INNINGS'
      } else if (this.plytyp == this.thirdInningsPlayType) {
        a = '_THIRD_INNINGS'
      } else if (this.plytyp == this.fourthInningsPlayType) {
        a = '_FOURTH_INNINGS'
      } else if (this.plytyp == this.fifthInningsPlayType) {
        a = '_FIFTH_INNINGS'
      } else if (this.plytyp == this.sixthInningsPlayType) {
        a = '_SIXTH_INNINGS'
      } else if (this.plytyp == this.seventhInningsPlayType) {
        a = '_SEVENTH_INNINGS'
      } else if (this.plytyp == this.eightthInningsPlayType) {
        a = '_EIGHTTH_INNINGS'
      } else if (this.plytyp == this.nineInningsPlayType) {
        a = '_NINETH_INNINGS'
      } else if (this.plytyp == this.OTPlayType) {
        a = '_OVERTIME'
      }

      var pt = this.sportAllBetLang['ALL_BET.SUBHEADER' + a]
      var bt = this.bettyp == this.mlBetType? this.sportAllBetLang['ALL_BET.SUBHEADER_ML']:this.sportAllBetLang['ALL_BET.SUBHEADER_1X2']
      if (this.isSpecial) {
        var st = this.specialLeagueCaption(this.allBetEvent, this.bettyp)
        sCapt = ' '+ st + ' (' + this.sportAllBetLang['ALL_BET.LBL_SPECIALS'] + ')'
      }

      return pt + bt + sCapt
    },
    showLeg() {
      this.show = (!this.show) ? true : false;
    },
    setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket(plytyp, onex2BetType) {
      if (this.selectMarket)
        this.selectMarket(this.allBetEvent, plytyp, onex2BetType, this.isSpecial)
    },
    removeFromMyMarket(plytyp, onex2BetType) {
      if (this.removeMarket)
        this.removeMarket(this.allBetEvent, plytyp, onex2BetType, this.isSpecial)
    },
    // oddsHeader(onex2BetType) {
    //   var retCapt = ''
    //   if (this.isSpecial) {
    //     retCapt += this.specialLeagueCaption(this.allBetEvent, onex2BetType)
    //   }
    //   return retCapt
    // },
  },
  mounted(){
    if(this.mode=='ab'){
      this.show = (this.$store.getters.foldopenAllBet) ? true : false;
    }else{
      this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
    }
  },
}
</script>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/allBet-1x2.vue